import { FunctionComponent } from 'react';

type RadialIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const RadialIcon: FunctionComponent<RadialIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-939 -1160)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(939 1160)"
          fill={circleFill}
        />
        <g transform="translate(-2 -2)">
          <g
            transform="translate(948 1169)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          >
            <circle cx="10" cy="10" r="10" stroke="none" />
            <circle cx="10" cy="10" r="9.4" fill="none" />
          </g>
          <g
            transform="translate(953 1174)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          >
            <circle cx="5" cy="5" r="5" stroke="none" />
            <circle cx="5" cy="5" r="4.4" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default RadialIcon;
